<input
  [checked]="checked()"
  (change)="handleChange($event)"
  [disabled]="disabled()"
  type="checkbox"
  class="toggle toggle-primary" />
